import { useSelector } from 'react-redux'
import { ILocalizationState } from 'shared/Types/appTypes'

interface LocalizationStore {
    localization: ILocalizationState
}

export function selectLocale({ localization }: LocalizationStore) {
    return localization.locale
}

export function useLocale () {
    return useSelector(selectLocale)
}
